import React from "react";
import { VERSION } from "@src/constants";
import { contactInfo } from "./footerData";
import { PhoneIcon, EmailIcon } from "@src/assets/svgIcons";
import { getCurrentYear } from "@src/utils/dateUtils";

import "./index.scss";

// Simple SVG icons

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-copyright">
        © {getCurrentYear()} Corvell. All rights reserved.
      </div>

      <div className="footer-contact-row">
        <span className="footer-label">
          <PhoneIcon /> Contact Us:
        </span>

        {contactInfo.phones.map((phone, index) => (
          <React.Fragment key={phone.number}>
            {index > 0 && <span className="footer-divider">or</span>}
            <a href={`tel:${phone.number}`} className="footer-phone">
              {phone.display}
            </a>
          </React.Fragment>
        ))}

        <span className="footer-divider">|</span>

        <a
          href={`mailto:${contactInfo.email.address}`}
          className="footer-email"
        >
          <EmailIcon /> {contactInfo.email.display}
        </a>
      </div>

      <div className="footer-version">{VERSION}</div>
    </footer>
  );
};

export default Footer;
